import React from 'react';
import Modal from '../../components/Modal';

const PaymentSuccessModal = ({ phone, ticketUrl, onClose }) => {
  const body = (
    <div className="flex flex-col justify-center items-center text-center space-y-5 py-8">
      <div className="w-20 h-20 rounded-full bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center shadow-lg shadow-emerald-500/30">
        <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <div>
        <h3 className="text-xl font-bold text-surface-900 mb-2">Ödəniş uğurla tamamlandı!</h3>
        <p className="text-sm text-surface-500 leading-relaxed max-w-sm">
          Biletiniz e-mail ünvanınıza göndərildi. <strong className="text-surface-700">Inbox</strong> və <strong className="text-surface-700">spam</strong> qovluğunuzu yoxlayın.
        </p>
      </div>
      {phone && (
        <div className="bg-surface-50 rounded-2xl px-5 py-3 text-sm text-surface-500">
          Sual varsa: <strong className="text-surface-900">{phone}</strong>
        </div>
      )}
    </div>
  );

  return (
    <Modal
      title=""
      body={body}
      buttons={
        <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
          {ticketUrl && (
            <a
              href={ticketUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto inline-flex justify-center rounded-2xl bg-emerald-600 px-6 py-3 text-sm font-semibold text-white hover:bg-emerald-500 transition"
            >
              Biletə Bax
            </a>
          )}
          <button
            onClick={() => onClose(false)}
            type="button"
            className="w-full sm:w-auto inline-flex justify-center rounded-2xl bg-surface-900 px-6 py-3 text-sm font-semibold text-white hover:bg-surface-800 transition"
          >
            Bağla
          </button>
        </div>
      }
    />
  );
};

export default PaymentSuccessModal;
